import React, { useState } from 'react'
import {
  BreadCrumbs,
  ConversionButton,
  Footer,
  PcTabHeader,
  SpHeader,
} from '@/components/util/entrypoint'
import * as style from './index.module.css'
import { useBreakpoint } from 'gatsby-plugin-breakpoints'

interface Props {
  readonly title: string
  readonly description: string
  readonly children: React.ReactNode
  readonly isOrangeBackGround?: boolean
  readonly latestProjects?: React.ReactNode
}

/** @file 下層ページで使用するテンプレートファイル */
export const BaseTemplate = ({
  children,
  title,
  description,
  isOrangeBackGround = false,
  latestProjects = false,
}: Props): React.JSX.Element => {
  const breakpoints = useBreakpoint()
  const { tablet } = breakpoints
  const [open, setOpen] = useState<boolean>(false)

  return (
    <div className={style.root}>
      {!tablet ? (
        <PcTabHeader />
      ) : (
        <SpHeader onClick={() => setOpen(!open)} open={open} />
      )}
      <section className={style.headerSection}>
        <div className={style.innerContent}>
          <p className={style.description}>{`“${description}”`}</p>
          <h1 className={style.title}>{title}</h1>
        </div>
        <BreadCrumbs />
      </section>
      {isOrangeBackGround ? (
        <section className={style.orangeContentSection}>
          <div className={style.orangeLayer}>
            <div className={style.innerContent}>{children}</div>
          </div>
          <div className={style.grayLayer}>
            <div className={style.innerContent}>{latestProjects}</div>
          </div>
        </section>
      ) : (
        <section className={style.contentSection}>
          <div className={style.innerContent}>{children}</div>
        </section>
      )}
      <section className={style.conversionSection}>
        <ConversionButton />
      </section>
      <Footer />
    </div>
  )
}
